import React from 'react';
import { connect } from 'react-redux';
import {
  Box, Typography, Button, makeStyles, Paper,
} from '@material-ui/core';
import gifCarrito from '../../../assets/img/marketPlace/CarritoGif.gif';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
    padding: theme.spacing(2),
  },
  errorCard: {
    backgroundColor: theme.body.warningCard.backgroundColor,
    borderRadius: '20px',
    padding: theme.spacing(6),
    textAlign: 'center',
    boxShadow: `0px 10px 25px ${theme.body.warningCard.boxShadow}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  gifContainer: {
    width: '150px',
    height: '150px',
    marginBottom: '28px',
  },
  title: {
    fontWeight: 700,
    color: theme.body.warningCard.title,
    fontSize: '28px',
    marginBottom: theme.spacing(4),
    fontFamily: '"Karla"',
    letterSpacing: 0,
  },
  retryButton: {
    backgroundColor: theme.body.warningCard.retryButton.backgroundColor,
    color: theme.body.warningCard.retryButton.color,
    padding: '12px 0',
    width: '112px',
    borderRadius: '10px',
    textTransform: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: theme.body.warningCard.retryButton.hover.backgroundColor,
      transform: 'translateY(-2px)',
      boxShadow: `0px 5px 15px ${theme.body.warningCard.retryButton.hover.boxShadow}`,
    },
  },
}));

const Warning = (props) => {
  const { redirectUrl } = props;
  const classes = useStyles();

  const handleRetry = () => {
    window.location.href = redirectUrl;
  };

  return (
    <Box className={classes.container}>
      <Paper elevation={0} className={classes.errorCard}>
        <img
          src={gifCarrito}
          alt="Carrito Vacío"
          className={classes.gifContainer}
        />
        <Typography variant="h2" className={classes.title}>
          ¡Aún no tienes productos en tu carrito!
        </Typography>
        <Button
          variant="contained"
          className={classes.retryButton}
          onClick={handleRetry}
        >
          <Typography
            style={{
              fontFamily: '"Karla"',
              fontSize: '16px',
              letterSpacing: '0.5px',
            }}
          >
            Regresar
          </Typography>
        </Button>
      </Paper>
    </Box>
  );
};

const mapStateToProps = (props) => ({
  redirectUrl: props.license.redirectUrl,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(Warning);
